const WebFont = require('webfontloader');

const _loadFont = (config) => {
  WebFont.load(config);
};

const _addFontClasses = (fonts) => {
  fonts.forEach((font) => {
    document.documentElement.classList.add(`wf-${font}-n4-active`);
  });
};

export const webfontLoader = () => {
  const myFontsConfig = {
    custom: {
      families: ['DIN2014-Light', 'DIN2014-Regular'],
      urls: [`/static/template-ahrend/fonts/myfonts.css`],
    },
    active: () => {
      _addFontClasses(['din2014light', 'din2014regular']);
    },
    timeout: 2000,
  };

  const typekitConfig = {
    custom: {
      families: ['utopia-std'],
      urls: [`/static/template-ahrend/fonts/typekit.css`],
    },
    active: () => {
      _addFontClasses(['utopiastd']);
    },
    timeout: 2000,
  };

  _loadFont(myFontsConfig);
  _loadFont(typekitConfig);
};
